import type { Timestamp } from 'firebase/firestore';

export type Project = 'PP' | 'CR' | 'FDR' | 'SIFops' | 'Onset' | 'Other';

export const PROJECTS: { value: Project; label: string }[] = [
  { value: 'PP', label: 'Peaceful Pathway' },
  { value: 'CR', label: 'Creditors Relief' },
  { value: 'FDR', label: 'Freedom Debt Resolutions' },
  { value: 'SIFops', label: 'SIFops CRM' },
  { value: 'Onset', label: 'Onset' },
  { value: 'Other', label: 'Other' }
];

export type ChecklistStatus = 'open' | 'in_progress' | 'completed' | 'archived';
export type ItemStatus = 'pending' | 'pass' | 'fail' | 'skip';

export type UserRole = 'admin' | 'qc';

export interface UserProfile {
  uid: string;
  email: string;
  displayName: string;
  role: UserRole;
  createdAt: Timestamp;
}

export interface Checklist {
  id: string;
  title: string;
  project: Project;
  description?: string;
  status: ChecklistStatus;
  createdBy: string;
  createdByName: string;
  assignedTo?: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  itemCount: number;
  passCount: number;
  failCount: number;
  pendingCount: number;
}

export interface ChecklistItem {
  id: string;
  checklistId: string;
  order: number;
  description: string;
  acceptanceCriteria?: string;
  status: ItemStatus;
  qcNotes?: string;
  screenshotUrl?: string;
  screenshotPath?: string;
  completedBy?: string;
  completedAt?: Timestamp;
  createdAt: Timestamp;
}
